// Utilities
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useMaterialUIController, setLayout } from '../../../context'
import { useMediaQuery } from 'react-responsive'

const DashboardLayout = props => {
  const [_, dispatch] = useMaterialUIController()
  const { pathname } = useLocation()

  useEffect(() => {
    setLayout(dispatch, 'dashboard')
  }, [dispatch, pathname])

  return (
    <div
      className={
        (props.hideMarginTop === true ? 'mt-[20px]' : 'mt-[60px]') +
        ' lg:mt-[60px] relative lg:pl-[90px]'
      }
    >
      <div className="md:px-5 dashboard-container">{props.children}</div>
    </div>
  )
}

export default DashboardLayout
